// 导入oneui样式
import '@yy/one-ui/es/style/antd/index.less'
import '@yy/one-ui/es/style/index.less'

// 覆盖自定义主题色
import '@/styles/ant.less'

// declare module
import '@/styles/index.less'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'
import advancedFormat from 'dayjs/plugin/advancedFormat'
// import { OneConfigProvider } from '@yy/one-config'
// import { oneConfig } from '@/services/one-config'

dayjs.extend(utc)
// 显示一年第n周的插件
dayjs.extend(weekOfYear)
// 提供更多格式化选择
dayjs.extend(advancedFormat)
// 显示一年第n个季度
dayjs.extend(quarterOfYear)
// 时区插件
dayjs.extend(timezone)

// sentry 初始化
import '@/services/sentry'

import { Provider } from 'react-redux'
import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import { I18nextProvider } from 'react-i18next'

import store from '@/store'
import App from './App'
import i18n from './i18n'
/** serviceWorker */
import * as serviceWorker from '@/serviceWorkerRegistration'

function render() {
  ReactDOM.render(
    <Provider store={store}>
      <Suspense fallback={null}>
        <I18nextProvider i18n={i18n}>
          {/* <OneConfigProvider> */}
          <App />
          {/* </OneConfigProvider> */}
        </I18nextProvider>
      </Suspense>
    </Provider>,
    document.getElementById('root')
  )
}

render()

if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./App', render)
}
if (process.env.NODE_ENV === 'development') {
  serviceWorker.unregister()
} else {
  // 加载sw
  serviceWorker.register()
}
